const StatsSection = () => {
    return (
        <section className="bg-blue-700 text-white py-10">
            <div className="container mx-auto px-4">
                <div className="grid grid-cols-2 md:grid-cols-3 gap-8 text-center">
                    <div>
                        <div className="stat-number text-amber-400">98%</div>
                        <div className="text-blue-200 text-sm font-medium mt-1">Scanning accuracy</div>
                    </div>
                    <div>
                        <div className="stat-number text-amber-400">15 min</div>
                        <div className="text-blue-200 text-sm font-medium mt-1">Average onboarding time</div>
                    </div>
                    <div>
                        <div className="stat-number text-amber-400">£0</div>
                        <div className="text-blue-200 text-sm font-medium mt-1">Extra hardware needed</div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default StatsSection;
